import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import NotifyButton from "./NotifyButton";

const Logo = () => (
  <div className="w-10 h-10 rounded-xl bg-ink-900 flex items-end justify-center gap-[3px] pb-2.5 pt-2.5 px-2.5">
    {[0, 1, 2, 3].map((i) => (
      <span
        key={i}
        className="w-[3px] rounded-full bg-white animate-equalize origin-bottom"
        style={{
          height: "100%",
          animationDelay: `${i * 0.18}s`,
          animationDuration: `${0.9 + i * 0.15}s`,
        }}
      />
    ))}
  </div>
);

const Header = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { to: "/", label: "Episodes" },
    { to: "/about", label: "About" },
  ];

  return (
    <header
      className={`sticky top-0 z-50 bg-white border-b transition-shadow duration-300 ${
        scrolled ? "border-slate-200 shadow-sm" : "border-slate-100"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center gap-3">
            <Logo />
            <div>
              <span className="block text-[15px] font-bold text-ink-900 tracking-tight leading-none">
                AWS Daily Updates
              </span>
              <span className="block text-[11px] text-slate-500 mt-0.5">
                AI-generated audio briefings
              </span>
            </div>
          </Link>

          <nav className="flex items-center gap-1">
            {navLinks.map((link) => {
              const active = location.pathname === link.to;
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${
                    active
                      ? "text-ink-900 bg-slate-100"
                      : "text-slate-500 hover:text-ink-900 hover:bg-slate-50"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <div className="hidden sm:block ml-3 pl-4 border-l border-slate-200">
              <NotifyButton variant="header" />
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
